import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  TotalBarSummary,
  TotalBarSummaryBody,
  TotalBarSummaryDivider
} from 'components/TotalsBar';
import {
  TotalBarSummaryWithTitle,
  TotalBarTitle
} from 'components/TotalsBar/styled';
import { useAppSelector } from 'store/hooks';
import { getNumberFromCurrency } from '../VendorsTable/helpers';
import {
  getSelectedTotal,
  getSelectedTotalDiscount
} from '../VendorsTable/slice';
import type { VendorsTotalsFooterProps } from './types';

export const VendorsTotalsFooter: FC<VendorsTotalsFooterProps> = ({ data }) => {
  const selectedTotal = useAppSelector(getSelectedTotal);
  const selectedTotalDiscount = useAppSelector(getSelectedTotalDiscount);
  const totalOwed = getNumberFromCurrency(data?.totalOwed);

  return (
    <TotalBarSummaryWithTitle>
      <TotalBarTitle>
        <FormattedMessage
          defaultMessage="Payment Balance"
          description="Vendor Table Page Totals Footer Title"
        />
      </TotalBarTitle>
      <TotalBarSummary>
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Discount"
              description="Vendor Table Page Totals Footer Discount Title"
            />
          }
          value={selectedTotalDiscount}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          title={
            <FormattedMessage
              defaultMessage="Total Owed"
              description="Vendor Table Page Totals Footer Total Owed Title"
            />
          }
          value={totalOwed}
        />
        <TotalBarSummaryDivider />
        <TotalBarSummaryBody
          highlighted
          title={
            <FormattedMessage
              defaultMessage="Selected Total"
              description="Vendor Table Page Totals Footer Selected Total Title"
            />
          }
          value={selectedTotal}
        />
      </TotalBarSummary>
    </TotalBarSummaryWithTitle>
  );
};
